import { render, staticRenderFns } from "./MemberListNew.vue?vue&type=template&id=51df4e48&scoped=true&"
import script from "./MemberListNew.vue?vue&type=script&lang=js&"
export * from "./MemberListNew.vue?vue&type=script&lang=js&"
import style0 from "./MemberListNew.vue?vue&type=style&index=0&id=51df4e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51df4e48",
  null
  
)

export default component.exports